export default "__VITE_ASSET__BQIv1es$__"